import { useQuery } from '@tanstack/react-query'
import api, { Token } from '~/api'
import { useUser } from '~/features/auth/api/useUser'

/**
 * The viewer's operatives.
 *
 * Global rather than dashboard-scoped: the menu bar avatar and the dashboard identity panel both
 * read it, and React Query dedupes them by key, so the two together are one request per five
 * minutes rather than one each.
 *
 * The page this replaces fetched these in a bare `useEffect` into three pieces of local state,
 * which meant no caching, no error path, and a refetch on every mount. `api.collection.userTokens`
 * is kept as the transport — note it is *not* `api.dashboard.operatives`, which points at
 * `/api/dashboard/operatives`, an endpoint that does not exist in the Django URLconf.
 */
export const useUserTokens = () => {
    const { data: user } = useUser()

    return useQuery<Token[]>({
        queryKey: ['user_tokens', user?.id],
        queryFn: () => api.collection.userTokens(),
        enabled: !!user?.is_auth,
        retry: false,
        staleTime: 1000 * 60 * 5,
    })
}
